import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree
} from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LangRedirectGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const langParam = route.queryParamMap.get('lang');
    const storedLang = localStorage.getItem('langCode') || 'en';

    const isRootRoute = route.routeConfig?.path === '' && route.url.length === 0;

    if (!langParam) {
      if (isRootRoute) {
        return this.router.createUrlTree(['/'], {
          queryParams: { lang: storedLang }
        });
      } else {
        const path = state.url.split('?')[0];
        return this.router.createUrlTree([path], {
          queryParams: { lang: storedLang }
        });
      }
    }

    return true;
  }
}
